import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import Modal from '../../../common/Modal';
import { renderGoalStatusIcon } from '../../../events/goals/Item';
import { requestDataIfNeeded } from '../../../updates/user-updates/duck';
import * as API from '../../../core/api';

class Item extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isModalOpen: false,
    };
  }

  handleEventDelete = () => {
    const { event, requestUserEventsDataIfNeeded } = this.props;

    API.del(`events/${event._id}`)
      // Immediately refresh all user events
      .then(this.handleModalClose)
      .then(requestUserEventsDataIfNeeded);
  };

  handleModalOpen = () => {
    this.setState({ isModalOpen: true });
  };

  handleModalClose = () => {
    this.setState({ isModalOpen: false });
  };

  render() {
    const { event, t } = this.props;
    const { isModalOpen } = this.state;
    const isGoalMemoItem = event.action === 'ADD_GOAL_MEMO';

    return (
      <div className="c-box-primary__box">
        <div className="c-box-primary__item u-display-flex u-justify-content-between u-align-items-center">
          <div className="u-display-flex u-align-items-center">
            {!isGoalMemoItem && renderGoalStatusIcon(event.data.goal.status)}
            <span className="u-font-italic c-box-primary__text display-linebreak">
              {isGoalMemoItem ? event.data.memo.content : event.data.goal.name}
            </span>
          </div>
          <div className="u-margin-left">
            <button
              onClick={this.handleModalOpen}
              className="c-btn c-btn--delete"
            />
          </div>
        </div>
        <Modal
          isOpen={isModalOpen}
          onRequestClose={this.handleModalClose}
          title={t('manageUpdates.remove.goalModalTitle')}
        >
          <p className="u-weight-light">
            {t('manageUpdates.remove.goalModalNote')}
          </p>
          <div className="u-text-center u-margin-bottom u-margin-top-huge">
            <div className="u-display-flex u-justify-content-around u-flex-wrap u-padding-horizontal-huge">
              <button
                className="c-btn c-btn-outline u-margin-vertical-micro"
                onClick={this.handleModalClose}
              >
                {t('general.cancel')}
              </button>
              <button
                className="c-btn c-btn-outline c-btn-outline--primary u-margin-vertical-micro"
                onClick={this.handleEventDelete}
              >
                {t('general.delete')}
              </button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

const mapDispatchToProps = {
  requestUserEventsDataIfNeeded: requestDataIfNeeded,
};

export default connect(
  null,
  mapDispatchToProps
)(translate()(Item));



// WEBPACK FOOTER //
// ./src/updates/user-updates/goals/Item.js